"use client";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from "@/app/admin/_common/ui/sheet";
import { formatShowDate } from "@/app/_utils/dayjs";
import { User } from "lucide-react";

function Field({ label, value }: { label: string; value?: string | null }) {
  return (
    <div className="grid gap-1">
      <span className="text-[11px] font-medium uppercase tracking-wide text-muted-foreground">{label}</span>
      <span className="text-[13px] text-foreground">{value || "-"}</span>
    </div>
  );
}

export default function GuestDetailsDrawer({
  open,
  onClose,
  order,
}: {
  open: boolean;
  onClose: () => void;
  order?: any;
}) {
  const guest = order?.guest_data ?? {};
  const previousShows = Array.isArray(order?.previous_shows) ? order.previous_shows : [];
  const dob = guest.date_of_birth ?? guest.dob;

  return (
    <Sheet open={open} onOpenChange={(next) => !next && onClose()}>
      <SheetContent className="flex w-full flex-col gap-5 overflow-y-auto sm:max-w-[380px]">
        <SheetHeader>
          <SheetTitle>
            <span className="inline-flex items-center gap-2 align-middle">
              <User className="size-4 flex-none text-muted-foreground" />
              Guest details
            </span>
          </SheetTitle>
          <SheetDescription>Read-only guest information.</SheetDescription>
        </SheetHeader>

        <div className="grid gap-4">
          <Field label="First name" value={guest.first_name} />
          <Field label="Last name" value={guest.last_name} />
          <Field label="Email" value={guest.email} />
          <Field label="Phone" value={guest.phone} />
          <Field label="Instagram" value={guest.instagram} />
          <Field label="Date of birth" value={dob ? formatShowDate(dob, "MM/DD/YYYY") : undefined} />
          <Field label="Notes" value={order?.notes} />
        </div>

        <div className="border-t border-border pt-4">
          <div className="mb-2 text-[13px] font-semibold text-foreground">Previous shows</div>
          {previousShows.length === 0 ? (
            <div className="text-[12.5px] text-muted-foreground">No previous shows found.</div>
          ) : (
            <div className="grid gap-2">
              {previousShows.map((show: any, i: number) => (
                <div
                  key={i}
                  className="flex items-center justify-between border-b border-border/60 pb-1.5 text-[13px]"
                >
                  <span className="text-foreground">{show.show_name}</span>
                  <span className="text-muted-foreground">
                    {show.timestamp ? formatShowDate(show.timestamp, "MM/DD/YYYY") : ""}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}
